import _slicedToArray from "F:/vue2.0+ vant/2024\u5E74\u9879\u76EE\u96C6\u5408/\u5143\u7FBF\u5B98\u7F51\u9879\u76EE\u96C6\u5408/\u5143\u7FBF\u82F1\u6587\u7248\u672C/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "F:/vue2.0+ vant/2024\u5E74\u9879\u76EE\u96C6\u5408/\u5143\u7FBF\u5B98\u7F51\u9879\u76EE\u96C6\u5408/\u5143\u7FBF\u82F1\u6587\u7248\u672C/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.concat.js";
import { ref, onMounted, reactive, watch, watchEffect } from "vue";
import { enGetMediaReportsList_url } from "@/api"; //引入发送请求获取数据的方法

import { useRouter, useRoute } from "vue-router";
import MiniPagination from "@/components/MiniPagination/index.vue";
export default {
  components: {
    MiniPagination: MiniPagination
  },
  name: "Media",
  setup: function setup() {
    var route = useRoute();
    var router = useRouter();
    var activeNames = ref(-1);
    var reportTitle = ref("News"); // 展开方法

    var toggleMore = function toggleMore(index) {
      activeNames.value = index;
    }; // 收起方法


    var retract = function retract(name) {
      activeNames.value = -1;
    };

    var reportsList = ref([]);
    var currentPage = ref(1);
    var pageSize = ref("5");
    var totalCount = ref("");
    var title = ref(""); // const wd = route.query.wd

    watch(function () {
      return route.hash;
    }, function () {
      // if(route.query.wd){
      //   title.value = route.query.wd
      // }else{
      //   title.value = ""
      // }
      // console.log('当前页面哈希值:', route.hash)
      if (route.hash == '#pressRelease') {
        reportTitle.value = "Press Release";
      } else if (route.hash == '#press') {
        reportTitle.value = "In the Press";
      } else {
        reportTitle.value = "News";
      }

      getMediaReportsList(route.hash);
    });

    function getMediaReportsList(_x) {
      return _getMediaReportsList.apply(this, arguments);
    }

    function _getMediaReportsList() {
      _getMediaReportsList = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(val) {
        var hash, params, result, newReportsList;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // console.log("这是接口部分hash=", val)
                hash = '';

                if (val == '#pressRelease') {
                  hash = '1';
                }

                if (val == '#press') {
                  hash = '2';
                }

                hash;
                params = {
                  currentPage: currentPage.value,
                  pageSize: pageSize.value,
                  title: title.value,
                  type: hash
                };
                _context.next = 7;
                return enGetMediaReportsList_url(params);

              case 7:
                result = _context.sent;

                if (result.code == 200) {
                  newReportsList = result.data.reportsList.map(function (item) {
                    var _item$publishDate$spl = item.publishDate.split('-'),
                        _item$publishDate$spl2 = _slicedToArray(_item$publishDate$spl, 3),
                        year = _item$publishDate$spl2[0],
                        month = _item$publishDate$spl2[1],
                        day = _item$publishDate$spl2[2];

                    var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
                    var monthName = months[parseInt(month) - 1]; // const ordinal = function (n) {
                    //   const s = ["th", "st", "nd", "rd"],
                    //     v = n % 100
                    //   return n + (s[(v - 20) % 10] || s[v] || s[0])
                    // } 
                    // ordinal()

                    var formattedDay = parseInt(day);
                    item.publishDate = "".concat(monthName, " ").concat(formattedDay, ", ").concat(year);
                    return item;
                  });
                  reportsList.value = newReportsList;
                  totalCount.value = result.data.totalCount; // console.log("reportsList=", result.reportsList)
                }

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _getMediaReportsList.apply(this, arguments);
    }

    onMounted(function () {
      if (route.hash == '#pressRelease') {
        reportTitle.value = "Press Release";
      }

      if (route.hash == '#press') {
        reportTitle.value = "In the Press";
      }

      getMediaReportsList(route.hash); //获取媒体报道列表
    });

    var jumpMediaDetail = function jumpMediaDetail(item) {
      if (item.jumpFlag == 1) {
        var url = item.jumpUrl;
        window.open(url);
      } else {
        router.push({
          path: '/mediaDetails',
          query: {
            reportId: item.reportId
          }
        });
        return;
      }
    };

    var handlePageChange = function handlePageChange(page) {
      currentPage.value = page;
      getMediaReportsList(route.hash);
    };

    return {
      reportsList: reportsList,
      currentPage: currentPage,
      pageSize: pageSize,
      totalCount: totalCount,
      title: title,
      activeNames: activeNames,
      reportTitle: reportTitle,
      retract: retract,
      toggleMore: toggleMore,
      jumpMediaDetail: jumpMediaDetail,
      handlePageChange: handlePageChange
    };
  }
};